/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/ban-types */
import { ConfigAssetLoaderService } from '../services/config-asset-loader.service';

export function ConfigLoaderProviderFactory(provider: ConfigAssetLoaderService): Function {
  return () => provider.load();
}
